import { defineComponent, watch } from 'vue'
import { debounce } from 'lodash-es'
import useModel from '@/components/utils/useModel'
import './index.scss'
import deepcopy from 'deepcopy'
import { colors } from '@/constants/schema/'

export default defineComponent({
  name: 'MultiColor',
  props: {
    value: {
      type: Array,
      default() {
        return []
      }
    }
  },
  emits: ['update:value'],
  setup(props, ctx) {
    const dataModel = useModel(() =>
      props.value.reduce((pre, cur, idx) => {
        pre[cur.name] = cur.color || colors[idx]
        return pre
      }, {})
    )

    const methods = {
      updateChange: debounce(function (val) {
        const newValue = deepcopy(props.value.map((item) => ({ ...item, color: val[item.name] })))
        ctx.emit('update:value', newValue)
      }, 900)
    }

    watch(() => dataModel.value, methods.updateChange, { deep: true })
    return () => (
      <div class="multi-color">
        {props.value.map(({ name }) => (
          <div class="multi-color-item">
            <n-tooltip effect="dark" placement="bottom">
              {{
                trigger: () => <span class="multi-color-item-label">{name}</span>,
                default: () => name
              }}
            </n-tooltip>
            <div class="multi-color-item-content">
              <n-color-picker v-model={[dataModel.value[name], 'value']} modes={['rgb', 'hex']} />
            </div>
          </div>
        ))}
      </div>
    )
  }
})
